"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperService = void 0;
const restservice_1 = require("./restservice");
const _ = require("underscore");
class HelperService extends restservice_1.RestService {
    onNavigate(navigateTo) {
        window.location.href = navigateTo;
    }
    flattenObject(ob) {
        const toReturn = {};
        for (const key in ob) {
            if (!ob.hasOwnProperty(key)) {
                continue;
            }
            if ((typeof ob[key]) === 'object') {
                const flatObject = this.flattenObject(ob[key]);
                for (const key2 in flatObject) {
                    if (!flatObject.hasOwnProperty(key2)) {
                        continue;
                    }
                    toReturn[key2] = flatObject[key2];
                }
            }
            else {
                toReturn[key] = ob[key];
            }
        }
        return toReturn;
    }
    flattenObjectwithExceptions(ob, plankeyArray) {
        const toReturn = {};
        for (const key in ob) {
            if (!ob.hasOwnProperty(key)) {
                continue;
            }
            if ((typeof ob[key]) === 'object' && _.indexOf(plankeyArray, 'key') !== -1) {
                const flatObject = this.flattenObject(ob[key]);
                for (const key2 in flatObject) {
                    if (!flatObject.hasOwnProperty(key2)) {
                        continue;
                    }
                    toReturn[key2] = flatObject[key2];
                }
            }
            else {
                toReturn[key] = ob[key];
            }
        }
        return toReturn;
    }
    getPosition(el) {
        let xPos = 0;
        let yPos = 0;
        while (el) {
            if (el.tagName === 'BODY') {
                const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
                const yScroll = el.scrollTop || document.documentElement.scrollTop;
                xPos += (el.offsetLeft - xScroll + el.clientLeft);
                yPos += (el.offsetTop - yScroll + el.clientTop);
            }
            else {
                xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
                yPos += (el.offsetTop - el.scrollTop + el.clientTop);
            }
            el = el.offsetParent;
        }
        return {
            x: xPos,
            y: yPos
        };
    }
    scroll(id) {
        const myElement = document.querySelector('#' + id);
        const position = this.getPosition(myElement);
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: position.y + (myElement.clientHeight / 2)
        });
    }
    convertToCSV(objArray, headerList, tableHeaderList) {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = 'S.No,';
        for (let i = 0; i < headerList.length; i++) {
            row += headerList[i] + ',';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';
        for (let i = 0; i < array.length; i++) {
            let line = (i + 1) + '';
            for (let j = 0; j < tableHeaderList.length; j++) {
                // eslint-disable-next-line prefer-const
                let head = tableHeaderList[j];
                // if (line != '') line += ','
                line += ',' + array[i][head];
            }
            str += line + '\r\n';
        }
        return str;
    }
    getCreditCardTypeDisplay(creditCardType) {
        if (creditCardType.toUpperCase() === 'AMEX' || creditCardType.toUpperCase() === 'AMERICANEXPRESS' || creditCardType.toUpperCase() === 'AMERICAN_EXPRESS') {
            return 'American Express';
        }
        else if (creditCardType.toUpperCase() === 'MASTER' || creditCardType.toUpperCase() === 'MASTERCARD' || creditCardType.toUpperCase() === 'MASTER_CARD') {
            return 'MasterCard';
        }
        else if (creditCardType.toUpperCase() === 'VISA') {
            return 'Visa';
        }
        else if (creditCardType.toUpperCase() === 'DISCOVER') {
            return 'Discover';
        }
        return creditCardType;
    }
    findClosestAncestor(element, cls) {
        while ((element = element.parentElement) && !element.classList.contains(cls)) {
            return element;
        }
    }
    getPager(totalItems, currentPage, pageSize) {
        /* eslint-disable */
        // calculate total pages
        // eslint-disable-next-line prefer-const
        let totalPages = Math.ceil(totalItems / pageSize);
        // currentPage = 1;
        // pageSize = 10;
        let startPage, endPage;
        // if (totalPages <= 10) {
        //     // less than 10 total pages so show all
        //     startPage = 1;
        //     endPage = totalPages;
        // } else {
        //     // more than 10 total pages so calculate start and end pages
        //     if (currentPage <= 6) {
        //         startPage = 1;
        //         endPage = 10;
        //     } else if (currentPage + 4 >= totalPages) {
        //         startPage = totalPages - 9;
        //         endPage = totalPages;
        //     } else {
        //         startPage = currentPage - 5;
        //         endPage = currentPage + 4;
        //     }
        // }
        if (totalPages <= 4) {
            startPage = 1;
            endPage = totalPages;
        }
        else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 4;
            }
            else if (currentPage + 1 >= totalPages) {
                startPage = totalPages - 3;
                endPage = totalPages;
            }
            else {
                startPage = currentPage - 1;
                endPage = currentPage + 1;
            }
        }
        // calculate start and end item indexes
        // eslint-disable-next-line prefer-const
        let startIndex = (currentPage - 1) * pageSize;
        // eslint-disable-next-line prefer-const
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        // create an array of pages to ng-repeat in the pager control
        let pages = _.range(startPage, endPage + 1);
        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
            /* eslint-enable */
        };
    }
    deepClone(thing, opts) {
        // eslint-disable-next-line prefer-const
        let newObject = {};
        /* eslint-disable */
        if (thing instanceof Array) {
            return thing.map((i) => { return this.deepClone(i, opts); });
        }
        else if (thing instanceof Date) {
            return new Date(thing);
        }
        else if (thing instanceof RegExp) {
            return new RegExp(thing);
        }
        else if (thing instanceof Function) {
            return opts && opts.newFns ?
                new Function('return ' + thing.toString())() :
                thing;
        }
        else if (thing instanceof Object) {
            Object.keys(thing).forEach((key) => {
                newObject[key] = this.deepClone(thing[key], opts);
            });
            return newObject;
        }
        else if ([undefined, null].indexOf(thing) > -1) {
            return thing;
        }
        else {
            if (thing.constructor.name === 'Symbol') {
                return Symbol(thing.toString()
                    .replace(/^Symbol\(/, '')
                    .slice(0, -1));
            }
            // return _.clone(thing);  // If you must use _ ;)
            return thing.__proto__.constructor(thing);
        }
    }
    convertToDateFormat(input) {
        let date = new Date(input);
        let year = date.getFullYear();
        let day = date.getDate();
        let month = date.getMonth();
        let promoMonth;
        let months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        for (let i = 0; i < months.length; i++) {
            if (month == i) {
                promoMonth = months[i];
                break;
            }
        }
        return promoMonth + " " + day + ", " + year;
    }
}
exports.HelperService = HelperService;
//# sourceMappingURL=helper.service.js.map